import BaseActionFilter from 'yoda-core-components/lib/helpers/Analytics/BaseActionFilter';
import {
    getDeviceType,
    getVersion,
    serviceErrorToAnalyticsFormat,
} from 'yoda-account-components/lib/analytics/DigitalAnalyticsHelper';

class GiftRegistryActionFilter extends BaseActionFilter {
    getGiftRegistryPageDL(store, data) {
        const { context } = store.getState();
        const deviceType = getDeviceType(context);
        const getGiftRegistryDL = this.updateCommonDigitalData();
        getGiftRegistryDL.page.pageInfo.pageName = data.pageName.toLowerCase();
        getGiftRegistryDL.page.pageInfo.pageType = 'registry';
        getGiftRegistryDL.page.pageInfo.siteSection = 'account';
        getGiftRegistryDL.page.pageInfo.deviceType = deviceType;
        getGiftRegistryDL.page.pageInfo.searchRedirect = '';
        getGiftRegistryDL.page.pageInfo.releaseVersion = context.__RELEASEVERSION__;
        getGiftRegistryDL.page.pageInfo.version = getVersion('yoda account');
        getGiftRegistryDL.page.category = {};
        getGiftRegistryDL.page.category.primaryCategory = 'registry';
        getGiftRegistryDL.page.category.subCategory1 = '';
        getGiftRegistryDL.page.category.subCategory2 = '';
        getGiftRegistryDL.page.category.department = 'registry';
        getGiftRegistryDL.error = serviceErrorToAnalyticsFormat({}); // set empty error
        return getGiftRegistryDL;
    }
}

export default GiftRegistryActionFilter;
